import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { H5, LI, UL } from '../../AbstractElements'
import SidebarSubMenu from './SidebarSubMenu'
import { RootState } from '../../ReduxToolkit/Store';
import { Pinned } from '../../Utils/Constants';
import { SidebarMenuItem } from '../../Types/Layout.type';
import { menuList } from '../../Data/Layout/SidebarMenuList';
import { useAuth } from '../../Context/AuthContext';
type SidebarNavProps = {
    onItemClick?: () => void; // adjust the signature based on your actual use
};
export default function SidebarNav({ onItemClick }: SidebarNavProps) {
    const { t } = useTranslation();
    const [activeMenu, setActiveMenu] = useState<string[]>([]);
    const { pinedMenu } = useSelector((state: RootState) => state.layout)
    const { hasPermission } = useAuth();

    // Helper to check recursive visibility
    const checkVisibility = (item: any): boolean => {
        // 1. Check direct permission with implied alternatives
        if (item.permission) {
            if (!hasPermission(item.permission)) {
                // If strict 'view' permission is missing, check if user has other rights to the module
                // e.g. 'maintenance.add' should probably allow seeing the 'maintenance' menu item
                if (item.permission.endsWith('.view')) {
                    const moduleBase = item.permission.replace('.view', '');
                    const alternatives = ['.add', '.edit', '.delete', '.approve', '.transfer', '.download', '.import'];
                    const hasAlternative = alternatives.some(action => hasPermission(`${moduleBase}${action}`));
                    if (!hasAlternative) return false;
                } else {
                    return false;
                }
            }
        }

        // 2. Check children visibility
        if (item.type === 'sub' || (item.children && item.children.length > 0)) {
            // If it has children, at least one must be visible
            if (item.children) {
                return item.children.some((child: any) => checkVisibility(child));
            }
            // If type is sub but no children array, it shouldn't show
            return false;
        }

        return true;
    };

    const shouldHideMenu = (items: any[]) => {
        return items.map((data) => data.title).every((titles) => pinedMenu.includes(titles || ""));
    }

    return (
        <UL className="sidebar-menu simple-list" id="simple-bar">
            <div className="simplebar-wrapper">
                <div className="simplebar-mask">
                    <div className="simplebar-offset">
                        <div className="simplebar-content-wrapper">
                            <div className="simplebar-content">
                                <LI className={`pin-title sidebar-main-title ${pinedMenu.length > 0 ? "show" : ""} `}>
                                    <div>
                                        <H5 className="sidebar-title f-w-700">{Pinned}</H5>
                                    </div>
                                </LI>
                                {menuList &&
                                    menuList.map((mainMenu: SidebarMenuItem, index) => {
                                        // Filter items based on recursive visibility
                                        const visibleChildren = mainMenu.items?.filter(item => checkVisibility(item));

                                        const hasVisibleChildren = visibleChildren && visibleChildren.length > 0;

                                        // Automatically hide section if it has no visible children
                                        if (!hasVisibleChildren) return null;

                                        // Also respect pinning logic for the section title
                                        const isHiddenByPin = shouldHideMenu(visibleChildren);

                                        return (
                                            <Fragment key={index}>
                                                <LI className={`sidebar-main-title ${isHiddenByPin ? 'd-none' : ''}`}>
                                                    <div>
                                                        <H5 className={`${mainMenu.lanClass ? mainMenu.lanClass : ''} f-w-700 sidebar-title`}>{(`${mainMenu.title}`)}</H5>
                                                    </div>
                                                </LI>
                                                <SidebarSubMenu menu={visibleChildren} activeMenu={activeMenu} setActiveMenu={setActiveMenu} level={0} onItemClick={onItemClick} />
                                            </Fragment>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </UL>
    )
}
